// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-group{display:flex;border:1px solid #c3c4be;border-radius:3px;overflow:hidden}.button-group>*:not(:last-child){border-right:1px solid #c3c4be}", ""]);
// Exports
module.exports = exports;
